import {Component, Input} from '@angular/core';
import {Farm} from "src/app/infrastructure/moovement-api/models/farm";

@Component({
  selector: 'app-metadata',
  imports: [],
  templateUrl: './metadata.html',
  styleUrl: './metadata.css',
})
export class Metadata {
  @Input() farm?: Farm;

}
